import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns'
import { Field, FieldRenderProps, } from '@progress/kendo-react-form';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import { IOption } from '../../../types/Form/IForm';

type DropdownState = {
    isOpen: boolean;
    data: IOption[];
    value: IOption;
    select?: IOption;
}
const DropdownField: FunctionComponent<FieldRenderProps> = formRenderProps => {
    const { field,
        value,
        touched,
        ...others
    } = formRenderProps;
    const activeItems: IOption[] = field.Options.filter(o => o.Enabled)
    const currentValues = field?.VALUES?.length > 0 ? activeItems.filter(i => field?.VALUES.indexOf(i.UID) > -1) : undefined;
    const maxDepth = field?.ConfigSettings?.MaxDepth;

    //Cascading field
    const parentItems = activeItems.filter(i => i.Parent_UID == '00000000-0000-0000-0000-000000000000')
    const [topLevelOptions, setTopLevelOptions] = useState<DropdownState>({ isOpen: false, data: parentItems, value: null, select: null });
    const [secondLevelOptions, setSecondLevelOptions] = useState<DropdownState>({ isOpen: false, data: [], value: null, select: null });
    const [thirdLevelOptions, setThirdLevelOptions] = useState<DropdownState>({ isOpen: false, data: [], value: null, select: null });
    const [fourthLevelOptions, setFourthLevelOptions] = useState<DropdownState>({ isOpen: false, data: [], value: null, select: null });
    const [fifthLevelOptions, setFifthLevelOptions] = useState<DropdownState>({ isOpen: false, data: [], value: null, select: null });

    //const defaultOption = activeItems.filter(o=> o.UID === field.ConfigSettings?.Default);
    const fieldChanged = (e) => {
        //console.log('fieldChanged',e);
        let fieldChange = { ...field, VALUES: [e.value.UID] }
        formRenderProps.onChange({ value: fieldChange });
    }
    const multiFieldChanged = (e) => {
        let fieldChange = { ...field, VALUES: e.value.map(v => v.UID) }
        formRenderProps.onChange({ value: fieldChange });
    }
    const parentChanged = (event) => {
        let fieldChange = { ...field, VALUES: [event.value.UID].filter(v => v !== undefined && v !== null) }
        formRenderProps.onChange({ value: fieldChange });

    }
    const secondLevelChanged = (event) => {
        let fieldChange = { ...field, VALUES: [topLevelOptions.value.UID, event.value.UID].filter(v => v !== undefined && v !== null) }
        formRenderProps.onChange({ value: fieldChange });
    }
    const thirdLevelChanged = (e) => {
        let fieldChange = { ...field, VALUES: [topLevelOptions.value?.UID, secondLevelOptions.value?.UID, e.value.UID].filter(v => v !== undefined && v !== null) }
        formRenderProps.onChange({ value: fieldChange });
    }
    const fourthLevelChanged = (e) => {
        let fieldChange = { ...field, VALUES: [topLevelOptions.value?.UID, secondLevelOptions.value?.UID, thirdLevelOptions.value?.UID, e.value.UID].filter(v => v !== undefined && v !== null) }
        formRenderProps.onChange({ value: fieldChange });
    }

    const fifthLevelChanged = (e) => {
        let fieldChange = { ...field, VALUES: [topLevelOptions.value?.UID, secondLevelOptions.value?.UID, thirdLevelOptions.value?.UID, fourthLevelOptions.value?.UID, e.value.UID].filter(v => v !== undefined && v !== null) }
        formRenderProps.onChange({ value: fieldChange });
        //setFifthLevelOptions((o) => o = {...o, value:e.value});
    }

    const blur = (level) => {
        if (level === 2) { setSecondLevelOptions((e) => e = { ...e, isOpen: false }); }
        if (level === 3) { setThirdLevelOptions((e) => e = { ...e, isOpen: false }); }
        if (level === 4) { setFourthLevelOptions((e) => e = { ...e, isOpen: false }); }
        if (level === 5) { setFifthLevelOptions((e) => e = { ...e, isOpen: false }); }
    }
    const open = (level) => {
        if (level === 2) { setSecondLevelOptions((e) => e = { ...e, isOpen: true }); }
        if (level === 3) { setThirdLevelOptions((e) => e = { ...e, isOpen: true }); }
        if (level === 4) { setFourthLevelOptions((e) => e = { ...e, isOpen: true }); }
        if (level === 5) { setFifthLevelOptions((e) => e = { ...e, isOpen: true }); }
    }
    const wrapper = useRef();
    //Reverse fill the dropdowns based on the selected value.
    useEffect(() => {
        const option1 = activeItems.filter(i => i.UID === field.VALUES[0])
        const option2 = activeItems.filter(i => i.UID === field.VALUES[1])
        const option3 = activeItems.filter(i => i.UID === field.VALUES[2])
        const option4 = activeItems.filter(i => i.UID === field.VALUES[3])
        const option5 = activeItems.filter(i => i.UID === field.VALUES[4])

        //const level1Items = activeItems?.filter(s=>(option1?.length > 0 ? s.Parent_UID == option1[0].UID : null));
        const level2Items = activeItems?.filter(s => (option1?.length > 0 ? s.Parent_UID === option1[0].UID : null));
        const level3Items = activeItems?.filter(s => (option2?.length > 0 ? s.Parent_UID === option2[0].UID : null));
        const level4Items = activeItems?.filter(s => (option3?.length > 0 ? s.Parent_UID === option3[0].UID : null));
        const level5Items = activeItems?.filter(s => (option4?.length > 0 ? s.Parent_UID === option4[0].UID : null));

        const select2 = { Value: (level2Items?.length > 0 ? 'Select' : option1?.length > 0 ? '(None)' : null) } as IOption
        const select3 = { Value: (level3Items?.length > 0 ? 'Select' : option2?.length > 0 ? '(None)' : null) } as IOption
        const select4 = { Value: (level4Items?.length > 0 ? 'Select' : option3?.length > 0 ? '(None)' : null) } as IOption
        const select5 = { Value: (level5Items?.length > 0 ? 'Select' : option4?.length > 0 ? '(None)' : null) } as IOption

        setTopLevelOptions((e) => e = { ...e, value: (option1?.length > 0 ? option1[0] : null) });
        setSecondLevelOptions((e) => e = { ...e, data: level2Items, value: (option2?.length > 0 ? option2[0] : null), select: select2 });
        setThirdLevelOptions((e) => e = { ...e, data: level3Items, value: (option3?.length > 0 ? option3[0] : null), select: select3 });
        setFourthLevelOptions((e) => e = { ...e, data: level4Items, value: (option4?.length > 0 ? option4[0] : null), select: select4 });
        setFifthLevelOptions((e) => e = { ...e, data: level5Items, value: (option5?.length > 0 ? option5[0] : null), select: select5 });
    }, [field.VALUES]);

    if (field.ConfigSettings?.Display === "0") {
        //Dropdown
        return (
            <div ref={wrapper}>
                <DropDownList {...others} popupSettings={{ className: "z500" }} value={currentValues?.length ? currentValues[0] : undefined} onChange={fieldChanged} defaultItem={{ Value: "Select" }} data={activeItems} textField="Value" dataItemKey='UID' />
            </div>)
    }
    else if (field.ConfigSettings?.Display === "1") {
        //Multi select
        return (
            <div ref={wrapper}>
                <MultiSelect {...others} popupSettings={{ className: "z500" }} value={currentValues} onChange={multiFieldChanged} data={field.Options} textField="Value" dataItemKey='UID' />
            </div>
        )
    }
    else if (field.ConfigSettings?.Display === "2") {
        //Cascading dropdowns
        return (
            <div ref={wrapper}>
                {/* {JSON.stringify(others)} */}
                <DropDownList popupSettings={{ className: "z500" }} value={topLevelOptions.value} onChange={parentChanged} onOpen={() => open(1)} defaultItem={{ Value: "Select" }} data={topLevelOptions.data} textField="Value" dataItemKey='UID' />
                {maxDepth > 1 && <DropDownList popupSettings={{ className: "z500" }} defaultItem={secondLevelOptions.select} value={secondLevelOptions.value} onChange={secondLevelChanged} opened={secondLevelOptions?.isOpen} onOpen={() => open(2)} onClose={() => blur(2)} onBlur={() => blur(2)} data={secondLevelOptions?.data} textField="Value" dataItemKey='UID' />}
                {maxDepth > 2 && <DropDownList popupSettings={{ className: "z500" }} defaultItem={thirdLevelOptions.select} value={thirdLevelOptions.value} onChange={thirdLevelChanged} opened={thirdLevelOptions?.isOpen} onOpen={() => open(3)} onClose={() => blur(3)} onBlur={() => blur(3)} data={thirdLevelOptions?.data} textField="Value" dataItemKey='UID' />}
                {maxDepth > 3 && <DropDownList popupSettings={{ className: "z500" }} defaultItem={fourthLevelOptions.select} value={fourthLevelOptions.value} onChange={fourthLevelChanged} opened={fourthLevelOptions?.isOpen} onOpen={() => open(4)} onClose={() => blur(4)} onBlur={() => blur(4)} data={fourthLevelOptions?.data} textField="Value" dataItemKey='UID' />}
                {maxDepth > 4 && <DropDownList popupSettings={{ className: "z500" }} defaultItem={fifthLevelOptions.select} value={fifthLevelOptions.value} onChange={fifthLevelChanged} opened={fifthLevelOptions?.isOpen} onOpen={() => open(5)} onClose={() => blur(5)} onBlur={() => blur(5)} data={fifthLevelOptions?.data} textField="Value" dataItemKey='UID' />}
            </div>
        )
    }
    return <></>
}

export default DropdownField;